import FormattedMessage from 'I18n/components/FormattedMessage';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import CampaignSelect from 'campaigns-lib/components/CampaignSelect';
import { useCallback } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CampaignFilter({
  hasCampaignsReadAccess,
  value,
  onChange,
  multi = false,
  showLabel = false,
  labelStyle,
  'data-test-id': dataTestId,
  buttonUse,
  anchorType,
  itemComponent,
  ButtonContent,
  id
}) {
  const handleChange = useCallback((sanitizedOptions, options, selectedOption) => {
    const sanitizedOptionsValue = sanitizedOptions.target.value;
    if (Array.isArray(sanitizedOptionsValue)) {
      onChange(sanitizedOptions, options);
    } else {
      onChange(syntheticEvent(sanitizedOptionsValue), selectedOption);
    }
  }, [onChange]);
  if (!hasCampaignsReadAccess) {
    return null;
  }
  const campaignSelect = /*#__PURE__*/_jsx(CampaignSelect, {
    multi: multi,
    value: value,
    onChange: handleChange,
    isFilter: true,
    uiSelectProps: {
      id,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaignSelect.allCampaigns"
      }),
      menuWidth: 300,
      buttonUse: buttonUse || 'transparent',
      anchorType,
      itemComponent,
      'data-test-id': dataTestId,
      ButtonContent,
      paddingInline: '0'
    }
  });
  if (showLabel) {
    return /*#__PURE__*/_jsx(InlineLabel, Object.assign({
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaignSelect.dashboardLabel"
      })
    }, labelStyle, {
      children: campaignSelect
    }));
  }
  return campaignSelect;
}